import { styled, Typography } from '@mui/material';
export const BlockTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.7em',
    padding: '4px 0',
}));
